import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-boolean-input-socket",
    templateUrl: "./boolean-input-socket.component.html",
    styleUrls: ["./boolean-input-socket.component.scss"],
    imports: [ToggleComponent],
})
export class BooleanInputSocketComponent {
    readonly $label = input.required<string>({alias: "label"})
    readonly $value = input<boolean | undefined>(undefined, {alias: "value"})
    readonly $connected = input(false, {alias: "connected"})
    readonly $disableEditingIfConnected = input(true, {alias: "disableEditingIfConnected"})

    readonly valueChange = output<boolean>()

    readonly $editingEnabled = computed(() => !(this.$connected() && this.$disableEditingIfConnected()))
}
